"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isClientSide = void 0;
/* eslint import/prefer-default-export:0 */
// To determine if we're running in a browser context.

var isClientSide = function isClientSide() {
  return typeof window !== 'undefined';
};

exports.isClientSide = isClientSide;